<template>
    <div class="fill-height pa-0 ma-0">
        <TicketZEditionWithDocument
            v-if="isEditable"
            :mode="mode"
            :companyId="companyId"
            :inZTillReceipt="zTillReceipt"
            :key="id"
            @updateZTill="updateZTill"
            @deleted="deleted"
        />
        <!-- <TicketZEdition
            v-else-if="isEditable"
            :mode="mode"
            :companyId="companyId"
            :inZTillReceipt="zTillReceipt"
            :key="id"
        /> -->
        <TicketZPage
            v-if="isStatic"
            :mode="mode"
            :companyId="companyId"
            :inZTillReceipt="zTillReceipt"
            :key="id"
            @deleted="deleted"
        />
        <!-- <TicketZPageMobile
            v-if="isStaticMobile"
            :companyId="companyId"
            :inZTillReceipt="zTillReceipt"
            :key="id"
            @deleted="deleted"
        /> -->
    </div>
</template>

<script lang="ts">
import { Apollo } from "@/decorators";

import TICKET_Z from "../../graphql/TicketZ.gql";

// import TicketZEdition from "./TicketZEdition.vue";
import TicketZPage from "./TicketZPage.vue";
import TicketZPageMobile from "./TicketZPageMobile.vue";
import TicketZEditionWithDocument from "./TicketZEditionWithDocument.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        // TicketZEdition,
        TicketZPage,
        TicketZPageMobile,
        TicketZEditionWithDocument,
    },
    emits: ["delete"],
})
export class ZTillReceipt extends Vue {
    @Prop({ default: "Router" }) mode: string;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "" }) id: string;

    @Apollo({
        query: TICKET_Z,
        variables() {
            return {
                idZTill: this.id,
            };
        },
        skip() {
            return !this.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.zTillReceipt) {
                    if (data.zTillReceipt.accountingItemImport) {
                        this.$router.replace({
                            name: "accountingItemZTillReceipt",
                            params: {
                                companyId: this.companyId,
                                zTillReceiptId: this.id,
                            },
                        });
                    } else {
                        this.zTillReceipt = data.zTillReceipt;
                    }
                }
            }
        },
    })
    zTillReceipt: any = null;

    updateZTill() {
        this.$apollo.queries.zTillReceipt.refetch();
    }

    get isStaticMobile() {
        if (this.$vuetify.display.mobile) return true;
        return false;
    }

    get isStatic() {
        if (this.$vuetify.display.mobile) return false;
        if (!this.zTillReceipt) return false;
        if (this.zTillReceipt.accountingItemImport) return true;
        if (this.zTillReceipt.documents) {
            for (const doc of this.zTillReceipt.documents) {
                if (doc.vatDeclaration) return true;
            }
        }
        return false;
    }

    get isEditable() {
        // if (this.$vuetify.display.mobile) return false;
        if (!this.zTillReceipt) return false;
        if (this.zTillReceipt.accountingItemImport) return false;
        if (this.zTillReceipt.documents) {
            for (const doc of this.zTillReceipt.documents) {
                if (doc.vatDeclaration) return false;
            }
        }
        return true;
    }

    deleted() {
        this.$emit("deleted", this.id);
    }
}

export default toNative(ZTillReceipt);
</script>
